import api from "services/api";

import { CampaignDraft, CampaignDraftItem, CampaignPanelState, CampaignSaveItem } from "./types";

export async function fetchCampaignPanel(workspaceId: string, templateId: string): Promise<CampaignPanelState> {
  const { data } = await api.get(`/v2/workspaces/${workspaceId}/apps/campaigns`, { params: { templateId } });
  return data.data as CampaignPanelState;
}

export async function saveCampaignPanel(
  workspaceId: string,
  body: { templateId: string; types: CampaignSaveItem[] },
): Promise<{ saved: unknown[]; state: CampaignPanelState | null }> {
  const { data } = await api.put(`/v2/workspaces/${workspaceId}/apps/campaigns`, body);
  return data.data;
}

export function draftFromState(state: CampaignPanelState): CampaignDraft {
  return Object.fromEntries(
    state.types.map((t) => {
      const params = { ...t.params };
      // Contributário só começa depois da implantação concluída: o rascunho nunca leva waitForImplantation falso.
      if (t.type === "contributario" && params.waitForImplantation === false) params.waitForImplantation = true;
      return [t.type, { type: t.type, isActive: t.isActive, params, reason: null } as CampaignDraftItem];
    }),
  );
}

/** Regras da extensão só seguem quando foram editadas: sem edição, o que está gravado fica. */
export function buildSaveBody(templateId: string, state: CampaignPanelState, draft: CampaignDraft): { templateId: string; types: CampaignSaveItem[] } {
  return {
    templateId,
    types: state.types.map((t) => {
      // Tipo que o rascunho não tem cai no item que draftFromState daria.
      const item = draft[t.type] ?? draftFromState({ ...state, types: [t] })[t.type];
      const { extensionRules, ...rest } = item;
      // baseIsActive é o do estado carregado, nunca o do rascunho.
      return extensionRules ? { ...rest, extensionRules, baseIsActive: t.isActive } : { ...rest, baseIsActive: t.isActive };
    }),
  };
}

/** Reexportada para não partir os imports; mora em v2/utils para a página pública não depender de Setup. */
export { errorMessageOf } from "v2/utils/errorMessageOf";
